import * as React from 'react';
import { PLUGIN_ID } from '../pluginId';

interface InitializerProps {
  setPlugin: (id: string) => void;
}

const Initializer: React.FC<InitializerProps> = ({ setPlugin }) => {
  const ref = React.useRef(setPlugin);
  React.useEffect(() => {
    ref.current(PLUGIN_ID);
  }, []);
  return null;
};

export default Initializer;
